import { useEffect } from 'react';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import { useIntercom } from '@zenbusiness/application-commons-intercom';
import { useSearchParams } from 'react-router-dom';

import AuthPageTemplate from '#client/components/Template/AuthPageTemplate';

const Logout = () => {
  const [searchParams] = useSearchParams({ redirectTo: '/' });

  const { logout: handleLogout } = useAuthentication();
  const { update: handleUpdateIntercom } = useIntercom();
  const handleLogoutCompleted = useClickstreamCallback('logoutCompleted');
  const handleUserUnidentified = useClickstreamCallback('userUnidentified');

  useEffect(() => {
    const redirectTo = searchParams.get('redirectTo');

    handleUpdateIntercom({});
    handleLogoutCompleted();
    handleUserUnidentified();
    handleLogout(redirectTo);

    // NOTE: Disabling exhaustive-deps because we only want to run this once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <AuthPageTemplate message="Logging out of your ZenBusiness account" />;
};

export default Logout;
